import Vue from 'vue'
import { addClass, removeClass } from 'element-ui/lib/utils/dom'

let hasModal = false
let hasInitZIndex = false
let zIndex = 1200

const getModal = function() {
  if (Vue.prototype.$isServer) return
    let modalDom = document.createElement('div')

    modalDom.addEventListener('touchmove', function(event) {
      event.preventDefault()
      event.stopPropagation()
    })

    modalDom.addEventListener('click', function() {
      PopupManager.doOnModalClick && PopupManager.doOnModalClick()
    })

  return modalDom
}

const instances = {}

const PopupManager = {
  modalFade: true,

  getInstance: function(id) {
    return instances[id]
  },

  register: function(id, instance) {
    if (id && instance) {
      instances[id] = instance
    }
  },

  deregister: function(id) {
    if (id) {
      instances[id] = null
      delete instances[id]
    }
  },

  nextZIndex: function(modal) {
    if (modal && PopupManager.zIndex > 1800 && !document.querySelector('.el-dialog__wrapper:not([style*="display: none"])')) {
      zIndex = 1200
    }
    return PopupManager.zIndex++
  },

  modalStack: [],

  doOnModalClick: function() {
    // const topItem = PopupManager.modalStack[PopupManager.modalStack.length - 1]
    // if (!topItem) return

    // const instance = PopupManager.getInstance(topItem.id)
    // if (instance && instance.closeOnClickModal) {
    //   instance.close()
    // }
    // 取显示的最高的弹窗
    const topPopup = getTopPopup()
    if (topPopup && topPopup.closeOnClickModal) {
      topPopup.handleClose
        ? topPopup.handleClose()
        : (topPopup.handleAction ? topPopup.handleAction('cancel') : topPopup.close())
    }
  },

  openModal: function(id, zIndex, dom, modalClass, modalFade) {
    if (Vue.prototype.$isServer) return
    if (!id || zIndex === undefined) return
    this.modalFade = modalFade

    const modalStack = this.modalStack

    for (let i = 0, j = modalStack.length; i < j; i++) {
      const item = modalStack[i]
      if (item.id === id) {
        return
      }
    }

    const modalDom = getModal()
    modalDom.setAttribute('data-id', id)

    addClass(modalDom, 'v-modal')
    if (this.modalFade && !hasModal) {
      addClass(modalDom, 'v-modal-enter')
    }
    if (modalClass) {
      let classArr = modalClass.trim().split(/\s+/)
      classArr.forEach(item => addClass(modalDom, item))
    }
    setTimeout(() => {
      removeClass(modalDom, 'v-modal-enter')
    }, 200)
    // setTimeout(() => {
      // addClass(modalDom, 'v-modal')
      // const boundClientRectLeft = document.body.getBoundingClientRect().x
      // const menuWidth = parseFloat(window.getComputedStyle(document.documentElement).getPropertyValue('--menu-width'))
      // if (boundClientRectLeft < 0) {
      //   const absValue = Math.abs(boundClientRectLeft)
      //   if (absValue >= menuWidth) {
      //     modalDom.style.left = 0
      //   }
      //   if (absValue < menuWidth) {
      //     modalDom.style.left = menuWidth - absValue + 'px'
      //   }
      // }
      // if (boundClientRectLeft === 0) {
      //   modalDom.style.left = menuWidth + 'px'
      // }
    // })

    if (dom && dom.parentNode && dom.parentNode.nodeType !== 11) {
      dom.parentNode.appendChild(modalDom)
    } else {
      document.body.appendChild(modalDom)
    }

    if (zIndex) {
      modalDom.style.zIndex = zIndex
    }
    modalDom.tabIndex = 0
    // modalDom.style.display = ''

    this.modalStack.push({ id: id, zIndex: zIndex, modalClass: modalClass, modalDom: modalDom })
  },

  closeModal: function(id) {
    const modalStack = this.modalStack
    if (modalStack.length > 0) {
      const currentIndex = modalStack.findIndex(item => item.id === id)
      if (currentIndex > -1) {
        const topItem = modalStack[currentIndex]
        const modalDom = topItem.modalDom

        if (topItem.modalClass) {
          let classArr = topItem.modalClass.trim().split(/\s+/)
          classArr.forEach(item => removeClass(modalDom, item))
        }

        if (modalDom.getAttribute('data-id') === id) {
          modalDom.parentNode.removeChild(modalDom)
        }

        modalStack.splice(currentIndex, 1)
      }
    }
  }
}

Object.defineProperty(PopupManager, 'zIndex', {
  configurable: true,
  get() {
    if (!hasInitZIndex) {
      // zIndex = (Vue.prototype.$ELEMENT || {}).zIndex || zIndex
      hasInitZIndex = true
    }
    return zIndex
  },
  set(value) {
    zIndex = value
  }
})

const getTopPopup = function() {
  if (Vue.prototype.$isServer) return
  if (PopupManager.modalStack.length > 0) {
    // const topPopup = PopupManager.modalStack[PopupManager.modalStack.length - 1]
    let nodeList = document.querySelectorAll('.v-modal')
    if (nodeList.length) {
      let list = Object.values(nodeList)
      if (list.length > 1) {
        list.sort((a, b) => parseInt(b.style.zIndex) - parseInt(a.style.zIndex))
      }
      let topDom = list[0]
      let id = topDom.getAttribute('data-id')
      const topPopup = PopupManager.modalStack.find(item => item.id === id)
      if (!topPopup) return
      const instance = PopupManager.getInstance(topPopup.id)
      return instance
    }
  }
}

if (!Vue.prototype.$isServer) {
  // handle `esc` key when the popup is shown
  window.addEventListener('keydown', function(event) {
    if (event.keyCode === 27) {
      const topPopup = getTopPopup()

      if (topPopup && topPopup.closeOnPressEscape) {
        topPopup.handleClose
          ? topPopup.handleClose()
          : (topPopup.handleAction ? topPopup.handleAction('cancel') : topPopup.close())
      }
    }
  })
}

export default PopupManager



// WEBPACK FOOTER //
// ./src/public/components/el-dialog/popup/popup-manager.js